module.exports = __webpack_public_path__ + "img/pin_gr.1fc37287.svg";